import { ChevronDown, SlidersHorizontal } from 'lucide-react';
import { useMediaQuery } from '../hooks/useMediaQuery';

export const ResponsiveActions = ({ children, testId, label = 'Reports & tools' }) => {
  const mobile = useMediaQuery('(max-width: 767px)');
  if (!mobile) return <div className="flex flex-wrap gap-2">{children}</div>;
  return <details className="w-full border border-neutral-200 rounded-md bg-white" data-testid={testId}>
    <summary className="flex items-center gap-2 px-3 py-2 text-sm font-medium cursor-pointer" data-testid={`${testId}-toggle`}>
      <SlidersHorizontal className="h-4 w-4" />{label}<ChevronDown className="h-4 w-4 ml-auto" />
    </summary>
    <div className="grid gap-2 p-3 border-t border-neutral-100">{children}</div>
  </details>;
};